import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getMscServiceCodeList(params) {
  return request({
    url: URL.mdm.basicData.mscServiceCode,
    method: 'get',
    params
  })
}

export function saveMscServiceCode(data) {
  return request({
    url: URL.mdm.basicData.mscServiceCode,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delMscServiceCode(uuid) {
  return request({
    url: URL.mdm.basicData.mscServiceCode + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
